import styles from "./contacts.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import AppBar from "../../components/appBar/appBar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';

const Contacts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const creators = t("contacts.creators", { returnObjects: true });

  return (
    <div className={styles.wrapperLogin}>
      <AppBar />

      <div className={styles.wrapperImage}>
        <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
      </div>

      <div className={`${styles.box} ${styles.boxContacts}`}>
        <img alt="logo1" className={styles.imageTitle} src={ImgBuilder.logo} />
        <div className={styles.containerImitation}>
          <p className={styles.titleBox}>{renderWithLineBreaksAndBold(t("contacts.title"))}</p>
          <p className={styles.textBox}>{renderWithLineBreaksAndBold(t("contacts.subtitle"))}</p>
        </div>
      </div>
      <div className={`${styles.box}`}>
        <p className={styles.textBox}>{renderWithLineBreaksAndBold(t("contacts.icp"))}</p>
        <div className={styles.containerBox}>
          <img alt="logo1" className={styles.imageContainerBox} src={ImgBuilder.jkuLIT} />
          <img alt="logo2" className={styles.imageContainerBox} src={ImgBuilder.jkuCP} />
        </div>
        <p className={styles.textBox}>{renderWithLineBreaksAndBold(t("contacts.explanation"))}</p>
      </div>
      <div className={`${styles.box}`}>
        <p className={styles.textBox}>{renderWithLineBreaksAndBold(t("contacts.call_to_action"))}</p>
        {/* <div className={styles.contactItem}>
          <img alt="logo1" className={styles.iconContactItem} src={ImgBuilder.emailIcon} />
          (Antonela Tommasel) antonela.Tommasel@jku.at
        </div> */}
        {creators.map((item, idx) => 
          <div  key={idx} className={styles.contactItem} >
            <img alt={`logo_${idx}`} className={styles.iconContactItem} src={ImgBuilder.emailIcon} />
            ({item.name}) {item.email}
          </div>
        )}
      </div>
      <div className={`${styles.box} ${styles.boxOpacity0}`}>
        <div onClick={() => navigate("/")} className={styles.buttonNavigation}>{renderWithLineBreaksAndBold(t("contacts.back_home"))}</div>
      </div>
    </div>
  );
};

export default Contacts;
